/* SI QUEMA storefront — cart state, scroll-scrubbed intro, media fallbacks. */
(function () {
  "use strict";

  /* ---------- storage: file:// and private mode can both throw ---------- */
  var mem = null;
  function read() {
    if (mem) return mem;
    try {
      var raw = window.localStorage.getItem("siquema.cart");
      mem = raw ? JSON.parse(raw) : [];
    } catch (e) { mem = []; }
    if (!Array.isArray(mem)) mem = [];
    return mem;
  }
  function write(next) {
    mem = next;
    try { window.localStorage.setItem("siquema.cart", JSON.stringify(next)); } catch (e) {}
    paintCount();
  }

  var Cart = {
    all: read,
    add: function (item) {
      var items = read().slice();
      var hit = items.filter(function (i) { return i.sku === item.sku; })[0];
      if (hit) hit.qty += item.qty || 1;
      else items.push({ sku: item.sku, title: item.title, unit: item.unit,
                        price: item.price, poster: item.poster, qty: item.qty || 1 });
      write(items);
    },
    setQty: function (sku, qty) {
      var items = read().slice().map(function (i) {
        if (i.sku === sku) i.qty = Math.max(0, qty);
        return i;
      }).filter(function (i) { return i.qty > 0; });
      write(items);
    },
    remove: function (sku) { Cart.setQty(sku, 0); },
    count: function () { return read().reduce(function (n, i) { return n + i.qty; }, 0); },
    subtotal: function () { return read().reduce(function (n, i) { return n + i.price * i.qty; }, 0); }
  };
  window.SiQuemaCart = Cart;

  function money(n) { return "$" + n.toFixed(2); }
  window.siquemaMoney = money;

  function paintCount() {
    var n = Cart.count();
    Array.prototype.forEach.call(document.querySelectorAll("[data-cart-count]"), function (el) {
      el.textContent = n;
    });
  }

  /* ---------- media: honest placeholder when an mp4 is not there yet ---------- */
  function guardMedia() {
    Array.prototype.forEach.call(document.querySelectorAll("video[data-src]"), function (v) {
      var stage = v.closest(".stage, .intro__stage");
      var src = v.getAttribute("data-src");
      v.addEventListener("error", function () { if (stage) stage.classList.add("is-missing"); }, true);
      v.addEventListener("loadeddata", function () { if (stage) stage.classList.remove("is-missing"); });
      var s = document.createElement("source");
      s.src = src; s.type = "video/mp4";
      s.addEventListener("error", function () { if (stage) stage.classList.add("is-missing"); });
      v.appendChild(s);
      v.load();
    });
  }

  /* ---------- lazy autoplay so a dozen clips don't all decode at once ---------- */
  function lazyPlay() {
    var vids = Array.prototype.slice.call(document.querySelectorAll(".view:not([hidden]) video[data-loop]"));
    if (!vids.length) return;
    if (!("IntersectionObserver" in window)) {
      vids.forEach(function (v) { v.play().catch(function () {}); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { if (!e.target.src || e.target.closest("[data-pack-stage]:not(.is-on)")) return; e.target.play().catch(function () {}); }
        else e.target.pause();
      });
    }, { rootMargin: "120px", threshold: 0.2 });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* ---------- scroll-scrubbed intro ---------- */
  function scrubIntro() {
    var section = document.querySelector(".view:not([hidden]) [data-intro]");
    if (!section || section.__wired) return;
    section.__wired = true;
    var loopV = section.querySelector("video[data-intro-loop]");
    var scrubV = section.querySelector("video[data-intro-scrub]");
    var bar = section.querySelector(".scrub b");
    if (!loopV || !scrubV) return;
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    /* Two clips.
       loop:  shot frames 0 -> 108 -> 0 as a 300-frame boomerang. Speed follows
              u = h - A*sin(2*pi*h)/(2*pi), so it hangs in slow motion (motion-
              interpolated frames) at both turns and runs at ~1.2x in between.
       scrub: the untouched shot, frames 0-149, keyframe every 6 frames.
       Scrolling starts the scrub at the exact shot frame the loop is showing and
       carries it forward to 149; scrolling back to the top hands it back to the
       loop at the same frame, still travelling the way it was. No cuts. */
    var FPS = 24, PEAK = 108, H = 150, A = 0.7, LAST = 149, TAU = Math.PI * 2;
    function ease(h) { return h - A * Math.sin(TAU * h) / TAU; }
    function loopFrame(t) { var k = (t * FPS) % (2 * H); return k <= H ? k : 2 * H - k; }
    function rawAtLoop(t) { return PEAK * ease(loopFrame(t) / H); }
    function loopTimeFor(raw, forward) {
      var lo = 0, hi = 1, m;
      for (var i = 0; i < 28; i++) { m = (lo + hi) / 2; if (PEAK * ease(m) < raw) lo = m; else hi = m; }
      var k = ((lo + hi) / 2) * H;
      return (forward ? k : 2 * H - k) / FPS;
    }

    var idle = true, r0 = 0, fwd = true, target = 0, current = 0, raf = null, ready = false, want = -1, busy = false;
    scrubV.addEventListener("loadedmetadata", function () { ready = isFinite(scrubV.duration) && scrubV.duration > 0; if (!idle) onScroll(); });
    scrubV.addEventListener("seeked", function () {
      if (!idle && want >= 0 && Math.abs(scrubV.currentTime - want) > 0.02) scrubV.currentTime = want;
    });
    loopV.loop = true;
    loopV.addEventListener("playing", function () { loopV.classList.add("is-playing"); });
    /* first paint is the poster <img>; the loop starts once the page has loaded so it never competes with it */
    /* the loop never downloads until the poster image has painted (see __sqGate) */
    window.__sqStartLoop = function () { if (!reduce && idle && loopV.src) loopV.play().catch(function () {}); };

    function once(v, fn) {
      var done = false, go = function () { if (done) return; done = true; v.removeEventListener("seeked", go); fn(); };
      v.addEventListener("seeked", go); setTimeout(go, 300);
    }
    function enterScroll() {
      var t = loopV.currentTime;
      fwd = (t * FPS) % (2 * H) <= H;
      r0 = rawAtLoop(t);
      loopV.pause();
      want = r0 / FPS; scrubV.currentTime = want;
      once(scrubV, function () { if (!idle) scrubV.classList.add("is-on"); });
    }
    function exitScroll() {
      var raw = Math.min(PEAK, scrubV.currentTime * FPS);
      loopV.currentTime = loopTimeFor(raw, fwd);
      once(loopV, function () {
        if (!idle) return;
        scrubV.classList.remove("is-on");
        if (!reduce) loopV.play().catch(function () {});
      });
    }
    function setIdle(on) {
      if (on === idle) return;
      if (!on && !ready) return;          /* scrub clip not loaded yet: keep looping */
      idle = on;
      if (on) exitScroll(); else enterScroll();
    }

    function progress() {
      var r = section.getBoundingClientRect();
      var total = section.offsetHeight - window.innerHeight;
      if (total <= 0) return 0;
      return Math.min(1, Math.max(0, -r.top / total));
    }
    function tick() {
      if (idle) { raf = null; current = 0; target = 0; return; }
      current += (target - current) * 0.12;
      var q = (typeof remapProgress === "function") ? remapProgress(current) : current;
      var t = Math.min(scrubV.duration - 0.04, (r0 + q * (LAST - r0)) / FPS);
      want = t;
      if (!scrubV.seeking && Math.abs(scrubV.currentTime - t) > 0.02) scrubV.currentTime = t;
      if (Math.abs(target - current) > 0.0008) raf = requestAnimationFrame(tick);
      else raf = null;
    }
    function onScroll() {
      var p = progress();
      setIdle(p < 0.004);
      if (idle) { if (bar) bar.style.width = "0%"; return; }
      target = p;
      if (bar) bar.style.width = (p * 100).toFixed(2) + "%";
      if (!raf) raf = requestAnimationFrame(tick);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    onScroll();
  }

  /* ---------- "Can't pick one?" orbit ---------- */
  /* File layout (24fps):
       0-157    the full orbit tour (reversed, ends on Mango) as a seamless loop (its last 0.5s dissolves
                back into its first 0.5s), plays on repeat while nobody is
                pointing at it
       158-185  the settled four-tub lineup, ping-ponged (orig frames 196-182-195)
     The tour keeps playing until the pointer lands on a tub. Then it dissolves
     from whatever tour frame is showing to the lineup and pushes the camera in
     on that tub (a transform on the live video) while the rest dims. Off the
     tubs, the camera pulls back and it dissolves back into the tour.
     Clicking a tub opens that flavor. */
  function orbitStage() {
    var stage = document.querySelector(".view:not([hidden]) [data-orbit-stage]");
    if (!stage || stage.__wired) return;
    stage.__wired = true;
    var video = stage.querySelector("video");
    var cam = stage.querySelector("[data-cam]");
    var spot = stage.querySelector("[data-spot]");
    var orbit = stage.querySelector("[data-orbit]");
    var cap = stage.querySelector("[data-cap]");
    if (!video || !cam || !orbit) return;

    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var canHover = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    /* The tour now plays in REVERSE (lineup -> Cucumber -> Watermelon -> Kiwi -> Mango) with the
       Kling Mango->Watermelon morph cut out and bridged by a short dissolve. Because the reversed
       tour starts on the lineup, the hover hold (158-185) is the tour's own opening frames
       ping-ponged, and leaving hover rejoins the tour right at its start. */
    var FPS = 24, LOOP_END = 160 / FPS, LOOP_REJOIN = 1 / FPS,
        HOLD_IN = 160 / FPS, HOLD_A = 160 / FPS, HOLD_B = 187 / FPS;
    var mode = "tour", inView = false, started = false, active = null, backT = null;
    /* data-once: the clip plays through one time and then holds on its last frame (the lineup) */
    var ONCE = stage.hasAttribute("data-once");
    var endPoster = video.getAttribute("data-poster-end");
    function endT() { return (isFinite(video.duration) && video.duration > 0) ? video.duration - 0.04 : 0; }
    if (ONCE) {
      var nc = navigator.connection || {};
      var noVid = reduce || !!(nc.saveData || /(^|-)(slow-2g|2g|3g)$/.test(nc.effectiveType || ""));

      if (noVid && endPoster) video.poster = endPoster;
    }
    var capDefault = cap ? cap.innerHTML : "";

    /* snapshot layer: freezes the current frame, the video jumps underneath, the snapshot fades out */
    var snap = document.createElement("canvas");
    snap.className = "orbit__snap";
    cam.insertBefore(snap, video.nextSibling);
    function jumpTo(t, still) {
      try {
        if (video.videoWidth) {
          snap.width = video.videoWidth; snap.height = video.videoHeight;
          snap.getContext("2d").drawImage(video, 0, 0);
          snap.classList.remove("is-fading"); snap.classList.add("is-on");
        }
      } catch (e) {}
      video.currentTime = t;
      video.addEventListener("seeked", function () {
        if (inView && !still) video.play().catch(function () {});
        requestAnimationFrame(function () { snap.classList.add("is-fading"); snap.classList.remove("is-on"); });
      }, { once: true });
    }

    function check() {
      if (video.seeking) return;
      if (ONCE) { if (video.ended && mode === "tour") mode = "done"; return; }
      var t = video.currentTime;
      if (mode === "tour" && t >= LOOP_END - 0.5 / FPS) video.currentTime = 0;
      else if (mode === "hold" && (t >= HOLD_B - 0.5 / FPS || video.ended)) { video.currentTime = HOLD_A; if (inView) video.play().catch(function () {}); }
    }
    function watch() {
      if (video.requestVideoFrameCallback) {
        var loop = function () { check(); video.requestVideoFrameCallback(loop); };
        video.requestVideoFrameCallback(loop);
      } else {
        (function raf() { check(); requestAnimationFrame(raf); })();
      }
      video.addEventListener("ended", check);
    }
    function toHold() {
      clearTimeout(backT); backT = null;
      if (mode === "hold") return;
      var wasDone = mode === "done";
      mode = "hold";
      if (ONCE) {
        video.pause();
        if (wasDone) return;
        if (endPoster) video.poster = endPoster;
        if (video.readyState >= 1) { if (video.currentTime < endT() - 0.05) { if (reduce) video.currentTime = endT(); else jumpTo(endT(), true); } }
        else if (video.getAttribute("src")) {
          video.addEventListener("loadedmetadata", function () { video.currentTime = endT(); }, { once: true });
          video.preload = "auto"; video.load();
        }
        return;
      }
      if (reduce) { video.currentTime = HOLD_IN; video.pause(); return; }
      jumpTo(HOLD_IN);
    }
    function toTour() {
      if (ONCE) {
        /* pulled back off the tubs: run the clip again from the top, then it holds on the lineup again */
        if (mode === "tour" || reduce || !video.getAttribute("src")) return;
        mode = "tour";
        if (video.readyState >= 1) jumpTo(0); else if (inView) video.play().catch(function () {});
        return;
      }
      if (mode === "tour" || reduce) return;
      mode = "tour";
      jumpTo(LOOP_REJOIN);
    }
    function begin() {
      if (started) { if (!ONCE || mode === "tour") video.play().catch(function () {}); return; }
      started = true;
      if (reduce) {
        mode = "hold";
        var park = function () { video.currentTime = ONCE ? endT() : HOLD_IN; video.pause(); };
        if (video.readyState >= 1) park(); else video.addEventListener("loadedmetadata", park, { once: true });
        return;
      }
      video.play().catch(function () {});
      watch();
    }
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          inView = e.isIntersecting;
          if (inView) begin(); else if (started) video.pause();
        });
      }, { threshold: 0.35 }).observe(stage);
    } else { inView = true; begin(); }
    /* the clip is deferred behind the media gate: once its source is wired, start it if we are already on screen */
    window.addEventListener("sq:gate", function () {
      if (inView && started && !reduce && (!ONCE || mode === "tour")) video.play().catch(function () {});
    });

    var hits = Array.prototype.slice.call(orbit.querySelectorAll("[data-tub]"));
    function layout() {
      var W = cam.clientWidth, H = cam.clientHeight, cs = getComputedStyle(video);
      var s = (cs.objectFit === "contain" ? Math.min : Math.max)(W / 1920, H / 1080), w = 1920 * s, h = 1080 * s;
      var x0 = (W - w) / 2, y0 = (H - h) / 2;
      hits.forEach(function (el) {
        var fx = parseFloat(el.getAttribute("data-x")), fw = parseFloat(el.getAttribute("data-w"));
        var l = x0 + fx * w, r = x0 + (fx + fw) * w, t = y0 + 0.26 * h, b = y0 + 0.74 * h;
        el.style.left = l + "px"; el.style.width = (r - l) + "px";
        el.style.top = t + "px"; el.style.height = (b - t) + "px";
        el.__c = [(l + r) / 2, y0 + 0.5 * h];
      });
      if (active) aim(active);
    }
    function aim(el) {
      var W = cam.clientWidth, H = cam.clientHeight, Z = 1.28;
      var cx = el.__c[0], cy = el.__c[1];
      var tx = (W / 2 + (cx - W / 2) * 0.3) - Z * cx;
      var ty = (cy - H * 0.05) - Z * cy;
      tx = Math.min(0, Math.max(W - Z * W, tx));
      ty = Math.min(0, Math.max(H - Z * H, ty));
      cam.style.transform = "translate(" + tx.toFixed(1) + "px," + ty.toFixed(1) + "px) scale(" + Z + ")";
      if (spot) {
        spot.style.setProperty("--sx", ((Z * cx + tx) / W * 100).toFixed(1) + "%");
        spot.style.setProperty("--sy", ((Z * cy + ty) / H * 100).toFixed(1) + "%");
        spot.classList.add("is-on");
      }
    }
    function show(el) {
      if (active === el) return;
      toHold();
      active = el;
      aim(el);
      if (cap) { cap.textContent = el.getAttribute("data-name") + " →"; cap.style.color = el.getAttribute("data-color"); }
    }
    function hide() {
      if (!active) return;
      active = null;
      cam.style.transform = "";
      if (spot) spot.classList.remove("is-on");
      if (cap) { cap.innerHTML = capDefault; cap.style.color = ""; }
    }
    /* back to the tour once the camera has pulled out and the pointer is gone */
    function leaveStage() { hide(); clearTimeout(backT); backT = setTimeout(function () { backT = null; if (!active) toTour(); }, 1150); }
    var outT = null;
    hits.forEach(function (el) {
      if (canHover) {
        el.addEventListener("pointerenter", function () { clearTimeout(outT); outT = null; show(el); });
      } else {
        /* touch: first tap pushes in on the tub, second tap opens it */
        el.addEventListener("click", function (e) { if (active !== el) { e.preventDefault(); show(el); } });
      }
      el.addEventListener("focus", function () { if (el.matches(":focus-visible")) show(el); });
      el.addEventListener("blur", function () { if (active === el) leaveStage(); });
    });
    if (canHover) {
      /* off the tubs for a beat (not just crossing a gap) pulls the camera back out */
      orbit.addEventListener("pointermove", function (e) {
        if (e.target.closest("[data-tub]")) { clearTimeout(outT); outT = null; }
        else if (active && !outT) outT = setTimeout(function () { outT = null; leaveStage(); }, 260);
      });
      orbit.addEventListener("pointerleave", function () { clearTimeout(outT); outT = null; leaveStage(); });
    } else {
      document.addEventListener("click", function (e) { if (active && !e.target.closest("[data-tub]")) leaveStage(); });
    }
    layout();
    window.addEventListener("resize", layout);
  }

  /* ---------- quantity / pack selector on product pages ---------- */
  /* smooth label swap: fade out, change text, fade in; remembers the intended text */
  function setLabel(el, text) {
    if (!el) return;
    el.__label = text;
    if (el.textContent === text) return;
    el.classList.add("is-swap");
    clearTimeout(el.__swapT);
    el.__swapT = setTimeout(function () { el.textContent = el.__label; el.classList.remove("is-swap"); }, 130);
  }
  window.siquemaSetLabel = setLabel;

  /* ---------- product page pack picker ----------
     The three pack clips sit stacked in one grid cell. Picking a pack starts that
     clip from frame 0 and only fades it in once it has a frame to show, so there
     is never a black gap or a layout jump. A token drops stale picks when someone
     clicks fast. Arrow keys move through the options (radio-group behaviour). */
  function packPicker() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-packs]"), function (group) {
      if (group.__wired) return; group.__wired = true;
      var scope = group.closest(".view") || document;
      var opts = Array.prototype.slice.call(group.querySelectorAll(".qty__opt"));
      var addBtn = scope.querySelector(".pdp__buy [data-add]") || scope.querySelector("[data-add]");
      var label = addBtn ? addBtn.querySelector("[data-add-label]") : null;
      var stages = Array.prototype.slice.call(scope.querySelectorAll("[data-pack-stage]"));
      var tok = 0, current = null, warmed = false;

      function warm() {
        if (warmed) return; warmed = true;
        stages.forEach(function (s) {
          var v = s.querySelector("video");
          if (v) { v.preload = "auto"; if (v.currentSrc && v.readyState === 0) v.load(); }
        });
      }
      group.addEventListener("pointerenter", warm);
      group.addEventListener("focusin", warm);
      group.addEventListener("touchstart", warm, { passive: true });

      function show(stage) {
        stages.forEach(function (s) {
          var on = s === stage;
          s.classList.toggle("is-on", on);
          s.setAttribute("aria-hidden", on ? "false" : "true");
          var v = s.querySelector("video");
          if (v && !on) { clearTimeout(s.__pauseT); s.__pauseT = setTimeout(function () { if (!s.classList.contains("is-on")) v.pause(); }, 450); }
          if (on) clearTimeout(s.__pauseT);
        });
      }
      function select(opt, focus) {
        if (!opt || opt === current) return;
        current = opt;
        opts.forEach(function (o) {
          var on = o === opt;
          o.setAttribute("aria-checked", String(on));
          o.tabIndex = on ? 0 : -1;
        });
        if (focus) opt.focus();
        var pack = opt.getAttribute("data-pack"), my = ++tok;
        var stage = stages.filter(function (s) { return s.getAttribute("data-pack-stage") === pack; })[0];
        if (stage) {
          var v = stage.querySelector("video");
          if (!v || stage.classList.contains("is-on")) { show(stage); if (v) v.play().catch(function () {}); }
          else {
            warm();
            try { v.currentTime = 0; } catch (e) {}
            var done = false, go = function () {
              if (done) return; done = true;
              v.removeEventListener("playing", go); v.removeEventListener("seeked", go);
              if (my !== tok) return;
              show(stage); v.play().catch(function () {});
            };
            if (v.readyState >= 3 && !v.seeking) { v.play().catch(function () {}); go(); }
            else {
              v.addEventListener("playing", go);
              v.addEventListener("seeked", go);
              v.play().catch(function () {});
              setTimeout(go, 650);      /* poster is already painted; never wait longer than this */
            }
          }
        }
        if (addBtn) {
          addBtn.setAttribute("data-sku", opt.getAttribute("data-sku"));
          addBtn.setAttribute("data-price", opt.getAttribute("data-price"));
          addBtn.setAttribute("data-unit", opt.getAttribute("data-unit"));
          addBtn.setAttribute("data-poster", opt.getAttribute("data-poster"));
          setLabel(label, "Add " + opt.getAttribute("data-unit") + " — " + money(parseFloat(opt.getAttribute("data-price"))));
        }
      }
      opts.forEach(function (o, i) {
        o.addEventListener("click", function () { select(o); });
        o.addEventListener("keydown", function (e) {
          var k = e.key, j = -1;
          if (k === " " || k === "Enter") { e.preventDefault(); select(o); return; }
          if (k === "ArrowDown" || k === "ArrowRight") j = (i + 1) % opts.length;
          else if (k === "ArrowUp" || k === "ArrowLeft") j = (i - 1 + opts.length) % opts.length;
          else if (k === "Home") j = 0; else if (k === "End") j = opts.length - 1;
          if (j >= 0) { e.preventDefault(); select(opts[j], true); }
        });
      });
      var init = opts.filter(function (o) { return o.getAttribute("aria-checked") === "true"; })[0] || opts[0];
      if (label) label.__label = label.textContent;
      select(init);
    });
  }

  /* ---------- add to cart ---------- */
  function addButtons() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-add]"), function (btn) {
      btn.addEventListener("click", function () {
        Cart.add({
          sku: btn.getAttribute("data-sku"),
          title: btn.getAttribute("data-title"),
          unit: btn.getAttribute("data-unit"),
          price: parseFloat(btn.getAttribute("data-price")),
          poster: btn.getAttribute("data-poster"),
          qty: 1
        });
        var label = btn.querySelector("[data-add-label]");
        if (!label) return;
        if (label.__label == null) label.__label = label.textContent;
        clearTimeout(label.__swapT); clearTimeout(label.__addT);
        label.classList.remove("is-swap");
        label.textContent = "Added to bag";
        btn.classList.add("is-added");
        label.__addT = setTimeout(function () { btn.classList.remove("is-added"); setLabel(label, label.__label); }, 1400);
      });
    });
  }


/* ---------- scroll-dwell remap (from the animated-website scroll engine) ----------
   Linear scrubbing races through the two frames the clip was actually built from.
   Gaussian dwell centers park the scroll on the supplied first and tail frames and
   move quickly through the interpolated middle, where the render is weakest. */
var DWELL_CENTERS = [0.07, 0.93], DWELL_WIDTH = 0.11, DWELL_PEAK = 3.0, REMAP_N = 1200;
var FWD = null;
function buildRemap() {
  var density = new Float64Array(REMAP_N + 1), cum = new Float64Array(REMAP_N + 1), i, j, x, d;
  for (i = 0; i <= REMAP_N; i++) {
    x = i / REMAP_N; d = 1;
    for (j = 0; j < DWELL_CENTERS.length; j++) {
      var t = (x - DWELL_CENTERS[j]) / DWELL_WIDTH;
      d += DWELL_PEAK * Math.exp(-0.5 * t * t);
    }
    density[i] = d;
  }
  cum[0] = 0;
  for (i = 1; i <= REMAP_N; i++) cum[i] = cum[i - 1] + (density[i - 1] + density[i]) / 2;
  var total = cum[REMAP_N] || 1;
  for (i = 0; i <= REMAP_N; i++) cum[i] /= total;
  FWD = cum;
}
/* invert: scroll position -> effective progress through the clip */
function remapProgress(p) {
  if (!FWD) buildRemap();
  if (p <= 0) return 0;
  if (p >= 1) return 1;
  var lo = 0, hi = REMAP_N, mid;
  while (hi - lo > 1) { mid = (lo + hi) >> 1; if (FWD[mid] < p) lo = mid; else hi = mid; }
  var span = FWD[hi] - FWD[lo];
  var frac = span > 0 ? (p - FWD[lo]) / span : 0;
  return (lo + frac) / REMAP_N;
}

/* ---------- pack clips: the tubs fill in once, then only the settled end loops
   (the file ends with that tail reversed, so jumping back to `from` is seamless) ---------- */
function holdLoop(v, from){
  if (v.__hold) return;
  v.__hold = true;
  v.loop = false; v.removeAttribute("loop");
  var back = function(){ try { v.currentTime = from; } catch (e) {} if (!v.paused || v.ended) v.play().catch(function(){}); };
  v.addEventListener("ended", function(){ v.currentTime = from; v.play().catch(function(){}); });
  if (v.requestVideoFrameCallback) {
    var tick = function(now, md){
      var d = v.duration;
      if (isFinite(d) && md && md.mediaTime >= d - 1.5 / 36 && !v.seeking) back();
      v.requestVideoFrameCallback(tick);
    };
    v.requestVideoFrameCallback(tick);
  }
}

/* ---------- media: every clip is embedded in this file ---------- */
function wireSources(){
  window.__sqWire = wireSources;
  Array.prototype.forEach.call(document.querySelectorAll("video[data-src]"), function (v) {
    if (v.__wired) return;
    if (v.hasAttribute("data-defer") && !window.__sqGate) return;
    v.__wired = true;
    var name = v.getAttribute("data-src").split("/").pop();
    var stage = v.closest(".stage, .intro__stage");
    if (window.VIDEO_HOLD && VIDEO_HOLD[name]) holdLoop(v, VIDEO_HOLD[name]);
    if (VIDEOS[name] && window.HOSTED) {
      v.addEventListener("loadeddata", function(){ if (stage) stage.classList.remove("is-missing"); });
      v.src = VIDEOS[name]; if (v.preload !== "none") v.load();
    } else if (VIDEOS[name]) {
      v.addEventListener("loadeddata", function(){ if (stage) stage.classList.remove("is-missing"); });
      fetch(VIDEOS[name]).then(function (r) { return r.blob(); })
        .then(function (b) { v.src = URL.createObjectURL(b); v.load(); })
        .catch(function () { v.src = VIDEOS[name]; v.load(); });
    } else if (stage) { stage.classList.add("is-missing"); }
  });
}

/* ---------- entrance: lift the curtain once the tunnel is on screen ---------- */
function curtain(){
  var root = document.documentElement, t0 = performance.now(), done = false;
  if (!document.getElementById("curtain")) { root.classList.add("ready", "lift", "gone"); return; }
  var MIN = 900, MAX = 5000;
  function lift(){
    if (done) return; done = true;
    var wait = Math.max(0, MIN - (performance.now() - t0));
    setTimeout(function(){
      root.classList.add("ready");
      setTimeout(function(){ root.classList.add("lift"); }, 220);
      setTimeout(function(){ root.classList.add("gone"); }, 1250);
    }, wait);
  }
  var intro = document.querySelector("#view-index:not([hidden]) .intro__media video");
  var fontsOk = !document.fonts || !document.fonts.ready ? Promise.resolve() : document.fonts.ready;
  var videoOk = intro ? new Promise(function(res){
      if (intro.readyState >= 2 && !intro.paused) return res();
      intro.addEventListener("playing", res, { once: true });
      intro.addEventListener("loadeddata", function(){ setTimeout(res, 120); }, { once: true });
    }) : Promise.resolve();
  Promise.all([fontsOk, videoOk]).then(lift);
  setTimeout(lift, MAX);
}

/* ---------- letter-split headline (animated-website skill) ---------- */
function letterSplit(){
  Array.prototype.forEach.call(document.querySelectorAll("[data-split]:not([data-split-done])"), function (el) {
    el.setAttribute("data-split-done","1");
    var text = el.textContent, out = "", i, ch;
    for (i = 0; i < text.length; i++){
      ch = text[i];
      out += (ch === " ")
        ? '<span class="ch sp">&nbsp;</span>'
        : '<span class="ch" style="transition-delay:' + (i * 42) + 'ms">' + ch + '</span>';
    }
    el.innerHTML = out;
    requestAnimationFrame(function(){ requestAnimationFrame(function(){ el.classList.add("split-in"); }); });
  });
}

/* ---------- scroll reveals + parallax ---------- */
var revealIO = null;
function reveals(){
  var items = Array.prototype.slice.call(document.querySelectorAll(".view:not([hidden]) .reveal:not(.in)"));
  if (!items.length) return;
  if (!("IntersectionObserver" in window)){ items.forEach(function(n){ n.classList.add("in"); }); return; }
  if (!revealIO) revealIO = new IntersectionObserver(function(es){
    es.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add("in"); revealIO.unobserve(e.target); } });
  }, { rootMargin: "0px 0px -8% 0px", threshold: 0.12 });
  items.forEach(function(n){ revealIO.observe(n); });
}
function parallax(){
  var nodes = Array.prototype.slice.call(document.querySelectorAll(".view:not([hidden]) [data-par]"));
  if (!nodes.length || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  function frame(){
    var vh = window.innerHeight;
    nodes.forEach(function(n){
      var r = n.getBoundingClientRect();
      var mid = (r.top + r.height / 2 - vh / 2) / vh;
      n.style.setProperty("--par", (mid * parseFloat(n.getAttribute("data-par"))).toFixed(2) + "px");
    });
  }
  if (!window.__parWired){
    window.__parWired = true;
    var ticking = false;
    window.addEventListener("scroll", function(){
      if (!ticking){ ticking = true; requestAnimationFrame(function(){ frame(); ticking = false; }); }
    }, { passive: true });
    window.addEventListener("resize", frame);
  }
  frame();
}

/* ---------- single-file router ---------- */
var ROUTES = ["index","mango","watermelon","kiwi-strawberry","cucumber-lime","variety-pack","cart","privacy","terms","refund","shipping","contact"];
function routeFromHash(){
  if (window.SQ_SHOP && window.SQ_SHOP.mode === "theme") return window.SQ_ROUTE || "index";
  var h = (location.hash || ("#" + (window.SQ_ROUTE || "index"))).slice(1);
  if (h.indexOf("index-") === 0) return "index";
  if (h.indexOf("privacy-") === 0) return "privacy";
  return ROUTES.indexOf(h) >= 0 ? h : "index";
}
function show(route){
  ROUTES.forEach(function(r){
    var v = document.getElementById("view-" + r);
    if (!v) return;
    var on = (r === route);
    v.hidden = !on;
    if (!on) Array.prototype.forEach.call(v.querySelectorAll("video"), function(x){ x.pause(); });
  });
  Array.prototype.forEach.call(document.querySelectorAll("[data-route]"), function(a){
    if (a.getAttribute("data-route") === route) a.setAttribute("aria-current","page");
    else a.removeAttribute("aria-current");
  });
  if (route === "cart" && window.SiQuemaRenderCart) window.SiQuemaRenderCart();
  lazyPlay(); scrubIntro(); orbitStage(); mailForms(); letterSplit(); reveals(); parallax(); navMode(route);
}
function navMode(route){
  var nav = document.querySelector(".nav");
  if (!nav) return;
  var onIntro = (route === "index");
  nav.classList.toggle("nav--float", onIntro);
  if (!onIntro) nav.classList.remove("nav--solid");
  if (!window.__navWired){
    window.__navWired = true;
    window.addEventListener("scroll", function(){
      var n = document.querySelector(".nav");
      if (!n || !n.classList.contains("nav--float")) return;
      n.classList.toggle("nav--solid", window.scrollY > window.innerHeight * 0.55);
    }, { passive: true });
  }
  var n = nav;
  if (onIntro) n.classList.toggle("nav--solid", window.scrollY > window.innerHeight * 0.55);
}
/* email capture -> Shopify customer (tags newsletter,welcome10) */
function mailForms(){
  Array.prototype.forEach.call(document.querySelectorAll("[data-mail]"), function (f) {
    if (f.__wired) return; f.__wired = true;
    var ok = f.parentNode.querySelector("[data-mail-ok]");
    if (window.SQ_SHOP && window.SQ_SHOP.mode === "theme") {
      f.method = "post"; f.action = "/contact#sq-mail"; f.id = "sq-mail";
      var em = f.querySelector('input[type="email"]'); if (em) em.name = "contact[email]";
      [["form_type","customer"],["utf8","✓"],["contact[tags]","newsletter,welcome10"]].forEach(function(kv){
        var i = document.createElement("input"); i.type = "hidden"; i.name = kv[0]; i.value = kv[1]; f.appendChild(i); });
      if (/customer_posted=true/.test(location.search)) { f.hidden = true; if (ok) ok.hidden = false; }
      return;
    }
    if (window.SQ_SHOP && window.SQ_SHOP.domain) {
      f.method = "post"; f.action = "https://" + window.SQ_SHOP.domain + "/contact#sq-mail";
      var em2 = f.querySelector('input[type="email"]'); if (em2) em2.name = "contact[email]";
      [["form_type","customer"],["utf8","✓"],["contact[tags]","newsletter,welcome10"]].forEach(function(kv){
        var i = document.createElement("input"); i.type = "hidden"; i.name = kv[0]; i.value = kv[1]; f.appendChild(i); });
      return;
    }
    f.addEventListener("submit", function (e) {
      e.preventDefault();
      f.hidden = true; if (ok) ok.hidden = false;
    });
  });
}
/* "Stack it and save": pick a flavour -> swap the clip, retarget the add-to-bag button */
var _blobs = {};
function clipURL(name){
  if (_blobs[name]) return Promise.resolve(_blobs[name]);
  if (!VIDEOS[name]) return Promise.reject();
  if (window.HOSTED) return Promise.resolve(VIDEOS[name]);
  return fetch(VIDEOS[name]).then(function(r){return r.blob()}).then(function(b){ return (_blobs[name] = URL.createObjectURL(b)); });
}
/* Double-buffered clip swap: the next clip loads in a second <video> stacked on
   the first and only fades in once it is actually playing. Stale requests from
   fast clicking are dropped by a token. */
function swapClip(stage, first, file, posterKey){
  if (stage.__file === undefined) stage.__file = (first.getAttribute("data-src") || "").split("/").pop();
  if (stage.__file === file) return;
  stage.__file = file;
  var cur = stage.__cur || first, nxt = stage.__nxt;
  if (!nxt) {
    nxt = document.createElement("video");
    nxt.__wired = true; nxt.muted = true; nxt.loop = true; nxt.playsInline = true;
    nxt.setAttribute("muted", ""); nxt.setAttribute("playsinline", ""); nxt.setAttribute("aria-hidden", "true");
    nxt.preload = "auto"; nxt.className = "v-back"; nxt.style.opacity = "0";
    stage.insertBefore(nxt, first.nextSibling);
    stage.__nxt = nxt;
  }
  stage.__cur = cur;
  var my = stage.__tok = (stage.__tok || 0) + 1;
  if (POSTERS[posterKey]) nxt.poster = POSTERS[posterKey];
  first.setAttribute("data-src", "videos/" + file);
  clipURL(file).then(function(u){
    if (my !== stage.__tok) return;
    var done = false;
    function flip(){
      if (done || my !== stage.__tok) return; done = true;
      nxt.style.zIndex = "1"; nxt.style.opacity = "1";
      cur.style.zIndex = "0"; cur.style.opacity = "0";
      var old = cur;
      setTimeout(function(){ if (my === stage.__tok) old.pause(); }, 450);
      stage.__cur = nxt; stage.__nxt = old;
    }
    nxt.addEventListener("playing", flip, { once: true });
    if (nxt.src !== u) { nxt.src = u; nxt.load(); } else { try { nxt.currentTime = 0; } catch (e) {} }
    nxt.play().catch(function(){});
    setTimeout(flip, 900);
  }).catch(function(){});
}
function stackCards(){
  Array.prototype.forEach.call(document.querySelectorAll("[data-stack]"), function(card){
    if (card.__wired) return; card.__wired = true;
    var pk = card.getAttribute("data-stack"), suffix = card.getAttribute("data-suffix"), unit = card.getAttribute("data-unit");
    var btn = card.querySelector("[data-add]"), label = btn.querySelector("[data-add-label]");
    var more = card.querySelector("[data-stack-more]"), vid = card.querySelector("video");
    var price = parseFloat(btn.getAttribute("data-price"));
    var chips = Array.prototype.slice.call(card.querySelectorAll(".stack__chip"));
    function pick(chip){
      chips.forEach(function(c){ var on = c === chip; c.setAttribute("aria-checked", String(on)); c.tabIndex = on ? 0 : -1; });
      var slug = chip.getAttribute("data-flv"), key = chip.getAttribute("data-key"), name = chip.getAttribute("data-name");
      card.style.setProperty("--flavor", chip.style.getPropertyValue("--flavor"));
      btn.setAttribute("data-title", name);
      btn.setAttribute("data-sku", slug + "-" + pk);
      btn.setAttribute("data-poster", "siquema_" + key + "_" + suffix + ".jpg");
      setLabel(label, "Add " + name + " " + unit.toLowerCase() + " — $" + price.toFixed(2));
      if (more) { more.setAttribute("href", (window.SQ_SHOP && window.SQ_SHOP.mode === "theme" ? "/products/" : "#") + slug); more.textContent = "See " + name + " →"; }
      var file = "siquema_" + key + "_" + suffix + ".mp4";
      if (vid) swapClip(vid.parentNode, vid, file, "siquema_" + key + "_" + suffix + ".jpg");
    }
    chips.forEach(function(c, i){
      c.tabIndex = c.getAttribute("aria-checked") === "true" ? 0 : -1;
      c.addEventListener("click", function(){ if (c.getAttribute("aria-checked") !== "true") pick(c); });
      c.addEventListener("keydown", function(e){
        var j = -1;
        if (e.key === "ArrowRight" || e.key === "ArrowDown") j = (i + 1) % chips.length;
        else if (e.key === "ArrowLeft" || e.key === "ArrowUp") j = (i - 1 + chips.length) % chips.length;
        if (j >= 0) { e.preventDefault(); chips[j].focus(); pick(chips[j]); }
      });
    });
    /* warm the other flavours' clips the moment someone reaches for this card */
    var warmed = false;
    function warm(){
      if (warmed) return; warmed = true;
      chips.forEach(function(c){
        var f = "siquema_" + c.getAttribute("data-key") + "_" + suffix + ".mp4";
        clipURL(f).then(function(u){
          if (!window.HOSTED) return;
          var l = document.createElement("link"); l.rel = "prefetch"; l.as = "video"; l.href = u; document.head.appendChild(l);
        }).catch(function(){});
      });
    }
    card.addEventListener("pointerenter", warm);
    card.addEventListener("focusin", warm);
    card.addEventListener("touchstart", warm, { passive: true });
  });
}
var SQ_LEGACY = {"index":"/","cart":"/cart","mango":"/products/mango","watermelon":"/products/watermelon",
  "kiwi-strawberry":"/products/kiwi-strawberry","cucumber-lime":"/products/cucumber-lime","variety-pack":"/products/variety-pack",
  "privacy":"/policies/privacy-policy","terms":"/policies/terms-of-service","refund":"/policies/refund-policy","shipping":"/policies/shipping-policy"};
function onHash(){
  var r = routeFromHash(), anchor = (location.hash||"").slice(1);
  if (window.SQ_SHOP && window.SQ_SHOP.mode === "theme") {
    /* old single-page links (#mango, #cart ...) now live at real URLs */
    if (SQ_LEGACY[anchor] && location.pathname !== SQ_LEGACY[anchor]) { location.replace(SQ_LEGACY[anchor]); return; }
    if (anchor.indexOf("index-") === 0 && location.pathname !== "/") { location.replace("/#" + anchor); return; }
    show(r);
    var tgt = anchor && document.getElementById(anchor);
    if (tgt) tgt.scrollIntoView({behavior: window.__sqBooted ? "smooth" : "auto"});
    window.__sqBooted = true;
    return;
  }
  show(r);
  if (anchor.indexOf("index-") === 0) {
    var el = document.getElementById(anchor);
    if (el) { el.scrollIntoView({behavior:"smooth"}); return; }
  }
  if (anchor.indexOf("privacy-") === 0) {
    var sec = document.getElementById(anchor.slice(8));
    if (anchor === "privacy-choices" && window.SQConsent) window.SQConsent.open(true);
    if (sec) { window.scrollTo(0,0); setTimeout(function(){ sec.scrollIntoView({behavior:"smooth"}); }, 60); return; }
  }
  window.scrollTo(0,0);
}

  function applyPosters(){
    Array.prototype.forEach.call(document.querySelectorAll("video[data-poster-key]"), function (v) {
      var k = v.getAttribute("data-poster-key");
      if (POSTERS[k]) v.poster = POSTERS[k];
      v.removeAttribute("data-poster-key");
    });
    Array.prototype.forEach.call(document.querySelectorAll("img[data-img-key]"), function (im) {
      var k = im.getAttribute("data-img-key");
      if (POSTERS[k]) im.src = POSTERS[k];
      im.removeAttribute("data-img-key");
    });
  }
  window.siquemaPoster = function (k) { return POSTERS[k] || k || ""; };
  document.addEventListener("DOMContentLoaded", function () {
    applyPosters(); wireSources(); packPicker(); stackCards(); addButtons(); paintCount();
    window.addEventListener("hashchange", onHash);
    onHash();
    curtain();
  });
})();

/* ---------- theme extras: mobile menu, PDP thumbnails, lazy scrub clip ---------- */
(function(){
  var btn = document.querySelector("[data-nav-toggle]"), nav = document.querySelector(".nav");
  if (btn && nav) {
    btn.addEventListener("click", function(){
      var open = !nav.classList.contains("nav--open");
      nav.classList.toggle("nav--open", open); btn.setAttribute("aria-expanded", open ? "true" : "false");
    });
    document.addEventListener("keydown", function(e){ if (e.key === "Escape" && nav.classList.contains("nav--open")) { nav.classList.remove("nav--open"); btn.setAttribute("aria-expanded","false"); btn.focus(); } });
  }
  Array.prototype.forEach.call(document.querySelectorAll("[data-thumb-pack]"), function(t){
    t.addEventListener("click", function(){
      var o = document.querySelector('.qty__opt[data-pack="' + t.getAttribute("data-thumb-pack") + '"]');
      if (o) o.click();
      var s = document.querySelector(".pack-stages"); if (s) s.scrollIntoView({behavior:"smooth", block:"center"});
    });
  });
  /* ---- media gate: no video bytes until the hero image has painted; none at all on Save-Data / slow links ---- */
  var c = navigator.connection || {};
  var slow = !!(c.saveData || /(^|-)(slow-2g|2g|3g)$/.test(c.effectiveType || ""));
  window.__sqSlow = slow;
  var scrub = document.querySelector("video[data-intro-scrub]");
  function warmScrub(){ if (!scrub || scrub.__warm || !window.__sqGate || slow) return; scrub.__warm = true; scrub.preload = "auto"; if (scrub.src) scrub.load(); }
  function playVisible(){
    Array.prototype.forEach.call(document.querySelectorAll("video[data-loop]"), function(v){
      if (!v.src || v.closest("[data-pack-stage]:not(.is-on)")) return;
      var r = v.getBoundingClientRect();
      if (r.bottom > 0 && r.top < innerHeight && r.width) v.play().catch(function(){});
    });
  }
  function openGate(){
    if (window.__sqGate || slow) return;
    window.__sqGate = true;
    if (window.__sqWire) window.__sqWire();
    playVisible();
    try { window.dispatchEvent(new Event("sq:gate")); } catch (e) {}
    if (window.__sqStartLoop) window.__sqStartLoop();
    setTimeout(warmScrub, 2500);
  }
  window.__sqOpenGate = openGate;
  if (!slow) {
    var done = false;
    var go = function(){ if (done) return; done = true; (window.requestIdleCallback || function(f){ return setTimeout(f, 200); })(openGate, { timeout: 1500 }); };
    var hero = document.querySelector('img[fetchpriority="high"]');
    try {
      if (window.PerformanceObserver && (PerformanceObserver.supportedEntryTypes || []).indexOf("largest-contentful-paint") >= 0) {
        var po = new PerformanceObserver(function(list){
          list.getEntries().forEach(function(en){
            if (!hero || en.element === hero || (en.url && hero.currentSrc && en.url === hero.currentSrc)) { po.disconnect(); go(); }
          });
        });
        po.observe({ type: "largest-contentful-paint", buffered: true });
      }
    } catch (e) {}
    if (hero) {
      var painted = function(){ requestAnimationFrame(function(){ requestAnimationFrame(function(){ setTimeout(go, 250); }); }); };
      if (hero.complete && hero.naturalWidth) painted(); else { hero.addEventListener("load", painted, { once: true }); hero.addEventListener("error", go, { once: true }); }
    }
    window.addEventListener("load", function(){ setTimeout(go, 1500); });
    setTimeout(go, 8000);
    ["pointerdown", "keydown", "touchstart"].forEach(function(t){ window.addEventListener(t, openGate, { once: true, passive: true }); });
    window.addEventListener("scroll", function(){ openGate(); warmScrub(); }, { passive: true });
  }
})();

window.SiQuemaRenderCart = function () {
  var C = window.SiQuemaCart, money = window.siquemaMoney;
  var lines = document.getElementById("lines"),
      sum = document.getElementById("summary"),
      empty = document.getElementById("empty");

  function draw() {
    var items = C.all();
    empty.hidden = items.length > 0;
    lines.innerHTML = "";
    sum.innerHTML = "";
    if (!items.length) return;

    items.forEach(function (i) {
      var row = document.createElement("div");
      row.className = "line";
      row.innerHTML =
        '<img src="' + window.siquemaPoster(i.poster) + '" alt="">' +
        '<div class="line__t"><b class="h3" style="font-size:20px">' + i.title + '</b>' +
        '<span class="flavor__notes">' + i.unit + ' &middot; ' + money(i.price) + '</span>' +
        '<span class="step"><button aria-label="Decrease">&minus;</button><span>' + i.qty +
        '</span><button aria-label="Increase">+</button></span></div>' +
        '<span class="price" style="font-family:var(--f-mono)">' + money(i.price * i.qty) + '</span>';
      var btns = row.querySelectorAll(".step button");
      btns[0].addEventListener("click", function () { C.setQty(i.sku, i.qty - 1); draw(); });
      btns[1].addEventListener("click", function () { C.setQty(i.sku, i.qty + 1); draw(); });
      lines.appendChild(row);
    });

    var sub = C.subtotal();
    var ship = 0;
    var SHOP = !!window.SQ_CHECKOUT;
    sum.innerHTML =
      '<div class="sum">' +
      '<div class="sum__row"><span>Subtotal</span><span>' + money(sub) + '</span></div>' +
      '<div class="sum__row"><span>Shipping</span><span>' + "Free" + '</span></div>' +
      '<div class="sum__row sum__row--tot"><span>' + (SHOP ? "Estimated total" : "Total") + '</span><span>' + money(SHOP ? sub : sub + ship) + '</span></div>' +
      '</div>' +
      '<div style="display:flex;flex-wrap:wrap;gap:12px;margin-top:26px">' +
      '<button class="btn btn--cta" id="checkout">Proceed to checkout</button>' +
      '<a class="btn btn--ghost" href="/#index-lineup">Keep shopping</a></div>' +
      (SHOP ? '<p class="note" style="margin-top:16px">Free shipping on every U.S. order. Taxes are calculated at checkout.</p>' :
      '<p class="note" style="margin-top:16px">Checkout is a front-end shell in this build &mdash; no payment processor is wired up yet.</p>');
    document.getElementById("checkout").addEventListener("click", function () {
      if (window.SQ_CHECKOUT) { this.textContent = "Loading checkout\u2026"; window.SQ_CHECKOUT(); return; }
      this.textContent = "Not wired up yet";
      var b = this; setTimeout(function () { b.textContent = "Proceed to checkout"; }, 1600);
    });
  }
  draw();
};


/* ---------- Shopify cart adapter (theme: AJAX cart API; permalink: hosted site -> Shopify checkout) ---------- */
(function(){
  var S = window.SQ_SHOP; if (!S) return;
  var C = window.SiQuemaCart; if (!C) return;
  function posterFor(sku){
    if (!sku) return "";
    if (sku.indexOf("variety") === 0) return "siquema_variety_pack.jpg";
    var m = sku.match(/^(.*)-(\d)$/); if (!m) return "";
    var key = m[1].replace(/-/g, "_");
    return "siquema_" + key + "_" + (m[2] === "1" ? "1tub" : m[2] === "2" ? "2pack" : "3pack") + ".jpg";
  }
  function onCart(){ var v = document.getElementById("view-cart"); return v && !v.hidden; }
  function paint(){
    var n = C.count();
    Array.prototype.forEach.call(document.querySelectorAll("[data-cart-count]"), function(el){ el.textContent = n; });
  }
  if (S.mode === "permalink") {
    window.SQ_CHECKOUT = function(){
      var items = C.all().filter(function(i){ return S.variants[i.sku]; });
      if (!items.length) return;
      location.href = "https://" + S.domain + "/cart/" + items.map(function(i){ return S.variants[i.sku] + ":" + i.qty; }).join(",");
    };
    return;
  }
  var cache = [];
  function fromShop(cart){
    cache = (cart.items || []).map(function(it){
      return { key: it.key, sku: it.sku || String(it.variant_id), title: it.product_title,
               unit: it.variant_title || "", price: it.final_price / 100,
               poster: posterFor(it.sku) || it.image, qty: it.quantity };
    });
    paint(); if (onCart() && window.SiQuemaRenderCart) window.SiQuemaRenderCart();
  }
  function refresh(){ return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function(r){ return r.json(); }).then(fromShop).catch(function(){}); }
  function post(url, body){ return fetch(url, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) }); }
  C.all = function(){ return cache; };
  C.count = function(){ return cache.reduce(function(n, i){ return n + i.qty; }, 0); };
  C.subtotal = function(){ return cache.reduce(function(n, i){ return n + i.price * i.qty; }, 0); };
  C.add = function(item){
    var id = S.variants[item.sku];
    if (!id) { console.warn("[siquema] no Shopify variant for SKU", item.sku); return; }
    var q = item.qty || 1, hit = cache.filter(function(i){ return i.sku === item.sku; })[0];
    if (hit) hit.qty += q; else cache.push({ sku: item.sku, title: item.title, unit: item.unit, price: item.price, poster: item.poster, qty: q });
    paint();
    post("/cart/add.js", { items: [{ id: id, quantity: q }] }).then(refresh, refresh);
  };
  C.setQty = function(sku, qty){
    var hit = cache.filter(function(i){ return i.sku === sku; })[0]; if (!hit) return;
    qty = Math.max(0, qty); hit.qty = qty; cache = cache.filter(function(i){ return i.qty > 0; }); paint();
    if (!hit.key) { refresh(); return; }
    post("/cart/change.js", { id: hit.key, quantity: qty }).then(function(r){ return r.json(); }).then(fromShop).catch(refresh);
  };
  C.remove = function(sku){ C.setQty(sku, 0); };
  window.SQ_CHECKOUT = function(){ location.href = "/checkout"; };
  refresh();
})();
